<template>
	<div>
		<Hrader :idShwo="3" @skipCompents="landingClcik"></Hrader>
		<div style="height: 70px"></div>
		<div>
			<img src="../../assets/contact_slices/Mask group@2x.png" style="width: 100%; height: 200rpx" />
		</div>

		<div class="rectangle" style="margin-top: -4px">
			<div class="rectangle-with">
				<div class="flex-rectange">
					<div>
						<img src="@/assets/recycling_slices/Vector@2x.png" style="width: 12px; height: 13px" />
					</div>
					<div class="current-recy">
						当前位置 : 卡券回收 ｜
						<span style="color: #ff3131">平台公告</span>
					</div>
				</div>
			</div>
		</div>

		<div class="rectangle-platform1">
			<div class="rectngle-plat-vector">
				<div class="rectng-width" :class="{ 'rectng-width1': ids == 2 }" @click="serverClick(2)">
					<img v-if="ids == 2" src="@/assets/contact_slices/Vector@2x (7).png" class="image-rectng" />
					<img v-else src="@/assets/contact_slices/Vector@2x(1).png" class="image-rectng" />
					<div class="title-assrts">常见问题</div>
				</div>
				<div class="rectng-width" :class="{ 'rectng-width1': ids == 1 }" @click="serverClick(1)">
					<img v-if="ids == 1" src="@/assets/contact_slices/Group211292x.png" class="image-rectng" />
					<img v-else src="@/assets/contact_slices/Group 1129@2x (1).png" class="image-rectng" />
					<div class="title-assrts">平台公告</div>
				</div>
				<div class="rectng-width" :class="{ 'rectng-width1': ids == 3 }" @click="serverClick(3)">
					<img v-if="ids == 3" src="@/assets/contact_slices/GroupValue.png" style="height: 16px; height: 16px" class="image-rectng" />
					<img v-else src="@/assets/contact_slices/Group 1137@2x.png" style="height: 16px; height: 16px" class="image-rectng" />
					<div class="title-assrts">回收流程</div>
				</div>
				<div class="rectng-width" :class="{ 'rectng-width1': ids == 8 }" @click="serverClick(8)">
					<img v-if="ids == 8" src="@/assets/Vector@2x (12).png" style="height: 16px; height: 16px" class="image-rectng" />
					<img v-else src="@/assets/Vector@2x (13).png" style="height: 16px; height: 16px" class="image-rectng" />
					<div class="title-assrts">企业资质</div>
				</div>
				<div class="rectng-width" :class="{ 'rectng-width1': ids == 4 }" @click="serverClick(4)">
					<img v-if="ids == 4" src="../../assets/contact_slices/Group 1139@2x1.png" style="height: 13px; height: 16px" class="image-rectng" />
					<img v-else src="../../assets/contact_slices/Group 1139@2x.png" style="height: 13px; height: 16px" class="image-rectng" />
					<div class="title-assrts">注册协议</div>
				</div>
				<div class="rectng-width" :class="{ 'rectng-width1': ids == 5 }" @click="serverClick(5)">
					<img v-if="ids == 5" src="../../assets/contact_slices/Group 1140@121x.png" style="width: 15px; height: 16px" class="image-rectng" />
					<img v-else src="../../assets/contact_slices/Group 1140@2x.png" style="width: 15px; height: 16px" class="image-rectng" />
					<div class="title-assrts">隐私政策</div>
				</div>
				<!-- <div class="rectng-width" :class="{ 'rectng-width1': ids == 6 }" @click="serverClick(6)">
					<img v-if="ids != 6" src="../../assets/contact_slices/Vector@2x.png" style="width: 16px; height: 13px" class="image-rectng" />
					<img v-else src="../../assets/contact_slices/Vector@2x (9).png" style="width: 16px; height: 13px" class="image-rectng" />
					<div class="title-assrts">商务合作</div>
				</div> -->
				<div class="rectng-width" :class="{ 'rectng-width1': ids == 7 }" @click="serverClick(7)">
					<img v-if="ids == 7" src="@/assets/contact_slices/Group 1138@22x1.png" style="width: 16px; height: 16px" class="image-rectng" />
					<img v-else src="@/assets/contact_slices/Group 11382x.png" style="width: 16px; height: 16px" class="image-rectng" />
					<div class="title-assrts">联系我们</div>
				</div>
			</div>
			<div class="content" v-if="ids == 1">
				<template v-if="showDetails">
					<div class="content-assets">
						<div class="flex-cement">
							<img v-if="ids == 1" src="@/assets/contact_slices/Group 1130@2x.png" style="width: 13px; height: 16px" />
							<img v-else src="@/assets/contact_slices/Vector@2x (6).png" style="width: 13px; height: 16px" />
							<div class="cement" v-if="ids == 1">平台公告</div>
							<div class="cement" v-else>常见问题</div>
						</div>
						<div class="border-top"></div>
						<div>
							<div class="flex-top" @click="aborConlerTop()">
								<div>
									<div class="flex-const-slice">
										<div>
											<img src="../../assets/contact_slices/Rectangle 258@2x.png" style="width: 5px; height: 5px" />
										</div>
										<div class="title-slice" style="width: 400px">{{ listData.content }}</div>
									</div>
									<div class="flex-const-slice" style="margin-left: 22px; margin-top: 8px">
										<div>
											<img src="../../assets/contact_slices/Vector@2x (5).png" style="width: 14px; height: 14px" />
										</div>
										<div class="december">2025年03月22日</div>
									</div>
								</div>
								<div>
									<img src="../../assets/contact_slices/Group 1148@2x.png" v-if="index == 0" style="width: 24px; height: 24px" />
									<img src="../../assets/contact_slices/Group 1148@2x (1).png" v-else style="width: 24px; height: 24px" />
								</div>
							</div>
						</div>
					</div>
				</template>
				<template v-else>
					<Detailsinfo :objList="listData" @closed="closedClick"></Detailsinfo>
				</template>
			</div>
			<div class="content" v-if="ids == 2">
				<template v-if="showDetails">
					<div class="content-assets">
						<div class="flex-cement">
							<img v-if="ids == 1" src="@/assets/contact_slices/Group 1130@2x.png" style="width: 13px; height: 16px" />
							<img v-else src="@/assets/contact_slices/Vector@2x (6).png" style="width: 13px; height: 16px" />
							<div class="cement" v-if="ids == 1">平台公告</div>
							<div class="cement" v-else>常见问题</div>
						</div>
						<div class="border-top"></div>
						<div v-for="(item, index) in dataListTitle" :key="index" @click="aborConler(item)">
							<div class="flex-top">
								<div>
									<div class="flex-const-slice">
										<div>
											<img src="../../assets/contact_slices/Rectangle 258@2x.png" style="width: 5px; height: 5px" />
										</div>
										<div class="title-slice" :class="{ 'title-slice1': true }">{{ item.question }}</div>
									</div>
									<div class="flex-const-slice" style="margin-left: 22px; margin-top: 8px">
										<div>
											<img src="../../assets/contact_slices/Vector@2x (5).png" style="width: 14px; height: 14px" />
										</div>
										<div class="december">{{ item.updateTime }}</div>
									</div>
								</div>
								<div>
									<img src="../../assets/contact_slices/Group 1148@2x.png" v-if="true" style="width: 24px; height: 24px" />
									<img src="../../assets/contact_slices/Group 1148@2x (1).png" v-else style="width: 24px; height: 24px" />
								</div>
							</div>
							<div class="border-top" v-if="dataListTitle.length != index+1"></div>
						</div>
						<div class="pagination-contact" v-if="0">
							<el-pagination background layout="total, prev, pager, next,jumper" :total="1000" />
						</div>
					</div>
				</template>
				<template v-else>
					<Details :objList="objList" @closed="closedClick"></Details>
				</template>
			</div>
			<template v-if="ids == 3">
				<Recovery></Recovery>
			</template>
			<template v-if="ids == 4 || ids == 5 || ids == 6 || ids == 8">
				<Registration :dataListObj="dataListObj" :ids="ids" :dataList="dataList" :dataImage="dataImage"></Registration>
			</template>
			<template v-if="ids == 7">
				<ContactUs></ContactUs>
			</template>
		</div>
	</div>
	<Tabr></Tabr>
	<div>
		<Customer></Customer>
	</div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter,useRoute } from 'vue-router';
import Tabr from '@/components/tabr.vue';
import Customer from '@/components/customer.vue';
import Details from './components/index.vue';
import Detailsinfo from './components/detailsinfo.vue';
import Recovery from './components/recovery.vue';
import Registration from './components/registration.vue';
import ContactUs from './components/contactUs.vue';
import Hrader from '@/components/header.vue';
import dayjs from 'dayjs';
import { infraonfigCompany, configUserProtocol, infrafilepdf, infraConfigPrivacyProtocol, cardListQa, appApiCardListQa, noticePub } from '@/utils/api.js';
let router = useRouter();
let route = useRoute();
let showDetails = ref(true);
let dataImage = ref('');
let dataList = ref([]);
let dataListObj = ref([]);
let title = ref('');
let objList = ref({});
let dataListTitle = ref([]);
let ids = ref(2);
let listData = ref('');
const skipClick = (item) => {
	console.log(item);
	router.push({ path: item });
};
const info = async () => {
	const res = await infraonfigCompany();
	dataImage.value = res.data.value;
	const ref = await configUserProtocol();
	const ret = await infrafilepdf({
		path: ref.data.value
	});
	dataList.value = ret.data;
	const dataRes = await infraConfigPrivacyProtocol();
	const retList = await infrafilepdf({
		path: dataRes.data.value
	});
	dataListObj.value = retList.data;
};
const into = async () => {
	const res = await cardListQa();
	console.log(res);
};
const serverClick = (item) => {
	closedClick();
	ids.value = item;
};
const infoSever = async () => {
	let ref = await appApiCardListQa();
	dataListTitle.value = ref.data;
	dataListTitle.value.forEach((item) => {
		item.updateTime = dayjs(item.updateTime).format('YYYY年MM月DD日');
	});
	if(route.query.id){
		ids.value = route.query.id;
		if(route.query.ids){
			let index = dataListTitle.value.findIndex(item=> item.id == route.query.ids);
			console.log(dataListTitle.value[index]);
			aborConler(dataListTitle.value[index]);
		}
	}
};

const aborConlerTop = () => {
	showDetails.value = false;
};

const aborConler = (item) => {
	objList.value = item;
	showDetails.value = false;
};
const closedClick = () => {
	showDetails.value = true;
};
const noticePubClick = async () => {
	let ref = await noticePub();
	console.log(ref.data);
	listData.value = ref.data;
};
onMounted(() => {
	info();
	into();
	infoSever();
	noticePubClick();
});
</script>

<style lang="scss">
.head-guidance {
	width: 100%;
	height: 70px;
	background: #ffffff;
	border-radius: 0px 0px 0px 0px;
	position: fixed;
	top: 0;
	z-index: 111;
	.head-guidance-flex {
		width: 100%;
		display: flex;
		justify-content: space-between;
		.image {
			width: 106px;
			height: 40px;
			margin-top: 15px;
			margin-left: 160px;
		}
	}
	.head-right {
		display: flex;
		margin-right: 104px;

		.head-right-flex {
			display: flex;
			align-items: center;
			margin-top: 12px;
			margin-left: 36px;

			.home-right {
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 16px;
				color: #333333;
				text-align: left;
				font-style: normal;
				text-transform: none;
				margin-left: 6px;
			}
		}

		.head-right-flex:hover {
			cursor: pointer;
		}

		.head-right-flex1:hover {
			cursor: pointer;
		}

		.head-right-flex1 {
			display: flex;
			align-items: center;
			padding: 11px 16px;
			background: #ff3333;
			border-radius: 74px 74px 74px 74px;
			margin-top: 13px;

			.home-right {
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 16px;
				color: #fff;
				text-align: left;
				font-style: normal;
				text-transform: none;
				margin-left: 6px;
			}
		}
		.frame-flex {
			height: 18px;
			border-right: 1px solid #dddddd;
			margin-top: 26px;
			margin-left: 22px;
			padding-right: 44px;
		}
	}
}

.rectangle {
	width: 100%;
	height: 52px;
	background: #ffffff;
	border-radius: 0px 0px 0px 0px;
}
.rectangle-with {
	width: 1280px;
	margin: auto;
	height: 52px;
}

.flex-rectange {
	display: flex;
	align-items: center;
	height: 52px;
	margin-left: 22px;
}

.current-recy {
	margin-left: 7px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #333333;
	font-style: normal;
	text-transform: none;
}

.rectangle-platform1 {
	width: 1280px;
	position: relative;
	margin: auto;
	margin-top: 21px;
	min-height: 420px;
}

.rectngle-plat-vector {
	width: 13%;
	padding: 10px 0px;
	background: #ffffff;
	border-radius: 8px 8px 8px 8px;
	position: absolute;
	left: 0;
	top: 0;
}

.rectng-width {
	width: 86%;
	height: 50px;
	border-radius: 0px 10px 10px 0px;
	display: flex;
	align-items: center;
}

.image-rectng {
	width: 13px;
	height: 16px;
	margin-left: 18px;
}

.title-assrts {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #333333;
	text-align: left;
	font-style: normal;
	text-transform: none;
	margin-left: 6px;
}
.rectng-width1 {
	background: linear-gradient(90deg, #ff3333 58%, rgba(255, 51, 51, 0.8) 100%);
	.title-assrts {
		color: #fff;
	}
}

.rectng-width:hover {
	cursor: pointer;
}

.content {
	width: 85%;
	background-color: #fff;
	margin-left: 20px;
	margin-left: auto;
}

.content:hover {
	cursor: pointer;
}

.content-assets {
	padding: 20px 21px;
	padding-: 26px;
}

.flex-cement {
	display: flex;
	align-items: center;

	.cement {
		font-family: PingFang SC, PingFang SC;
		font-weight: 600;
		font-size: 20px;
		color: #333333;
		margin-left: 8px;
		font-style: normal;
		text-transform: none;
	}
}

.border-top {
	width: 99%;
	height: 0px;
	border-top: 1px solid #eeeeee;
	margin-top: 16px;
	padding-top: 16px;
}

.flex-const-slice {
	display: flex;
}
.title-slice {
	margin-left: 14px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 18px;
	color: #333333;
	text-align: left;
	font-style: normal;
	text-transform: none;
	margin-top: 2px;

	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.title-slice1 {
	color: #ff2f17;
}

.december {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 17px;
	color: #aaaaaa;
	font-style: normal;
	text-transform: none;
	margin-left: 5px;
	margin-top: -2px;
}

.flex-top {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.flex-top {
	cursor: pointer;
}

.pagination-contact {
	margin-top: 60px;
}
.el-pagination.is-background .btn-next.is-active,
.el-pagination.is-background .btn-prev.is-active,
.el-pagination.is-background .el-pager li.is-active {
	background-color: #ff3333;
}
</style>
